import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../../../../../utils/Common/Constant";
import { Bullets, PieChartComponent } from "ui-components";
import "./ScoreCalculationSidebar.scss";
import { useState } from "react";
interface ScoreCalculationSidebarProps {
  data: any;
  scoreCalculation: any;
}
const ScoreCalculationSidebar = ({
  data,
  scoreCalculation,
}: ScoreCalculationSidebarProps) => {
  const { t } = useTranslation();
  const [hoveredItem, setHoveredItem] = useState<any>(null);
  const pieChartData = scoreCalculation.map((item: any) => ({
    name: capitalizeFirstLetter(item.parameter),
    value: item.finalPercentage ? item.finalPercentage : "",
    matchedPercentage: item.matchedPercentage,
    weightage: item.weightage,
  }));
  const colors = [
    "#35D4AE",
    "#e4aaaa",
    "#a594f9",
    "#D468FF",
    "#6d9cea",
    "#F49C46",
  ];
  const nameColorMap = pieChartData.map((item: any, index: any) => ({
    name: item.name,
    color: colors[index % colors.length], // Ensures colors cycle if more names exist
    percentage: item?.value ? item?.value : 0,
  }));
  const total = nameColorMap.reduce(
    (sum: number, item: any) => sum + item.percentage,
    0,
  );
  const unmatchedPercentage = 100 - total;
  nameColorMap.push({
    name: "Unmatched",
    color: "#e0e0e0",
    percentage: unmatchedPercentage,
  });

  return (
    <div className="scoreCalculationSidebarSection">
      <div className="candidateInfoSec">
        <span className="candidateName">
          {data?.firstName} {data?.lastName}
        </span>
        <div className="candidateEmailSource">
          <div className="userEmail">
            <span>{data?.email}</span>
          </div>
          <div className="sourceName">
            <span>{t("RESUME.SCANNING_SOURCE")} : </span>
            <span className="userEmail">
              {data?.source ? capitalizeFirstLetter(data?.source) : "-"}
            </span>
          </div>
        </div>
      </div>
      <div className="divider">
        <hr />
      </div>
      <div className="cvExtractDetailsSec">
        {/* ------------Experience */}
        <div className="cvExtractDetailRow">
          <div className="titleWithValue">
            <div className="d-flex gap-1">
              <div className="title">{t("GENERAL.EXPERIENCE")}</div>
              <div className="percentage">
                {data?.expRelevancy ? `(${data?.expRelevancy}%)` : "-"}
              </div>
            </div>
            <div className="value">
              {data?.relevantExp} {t("GENERAL.YEARS")}
            </div>
          </div>
        </div>
        {/* ------------Matched skills */}
        <div className="cvExtractDetailRow">
          <div className="cvExtractDetailRow">
            <div className="titleWithValue">
              <div className="d-flex gap-1">
                <div className="title">{t("GENERAL.MATCHED_SKILLS")}</div>
                <div className="percentage">
                  {data?.relevantSkills
                    ? `(${data?.relevantSkills?.split(",")?.length})`
                    : "-"}
                </div>
              </div>
              <div className="skillsNameChips">
                {data?.relevantSkills?.length
                  ? data?.relevantSkills
                      ?.split(",")
                      ?.map((item: string, index: any) => {
                        return (
                          <div key={index} className="skillsBullets">
                            <Bullets skillName={capitalizeFirstLetter(item)} />
                          </div>
                        );
                      })
                  : "-"}
              </div>
            </div>
          </div>
        </div>
        {/* ------------unmatched skills */}
        <div className="cvExtractDetailRow">
          <div className="cvExtractDetailRow">
            <div className="titleWithValue">
              <div className="title">{t("GENERAL.UNMATCHED_SKILLS")}</div>
              <div className="skillsNameChips">
                {data?.unmatchedSkill?.length
                  ? data?.unmatchedSkill
                      ?.split(",")
                      ?.map((item: string, index: any) => {
                        return (
                          <div
                            key={index}
                            className="skillsBullets greyKeywords"
                          >
                            <Bullets skillName={capitalizeFirstLetter(item)} />
                          </div>
                        );
                      })
                  : "-"}
              </div>
            </div>
          </div>
        </div>
        {/*---------------- project skills */}
        <div className="cvExtractDetailRow">
          <div className="cvExtractDetailRow">
            <div className="titleWithValue">
              <div className="d-flex gap-1">
                <div className="title">{t("RESUME.SCANNING_PROJECTS")}</div>
                <div className="percentage">
                  {data?.projectRelevantSkills
                    ? `(${data?.projectRelevantSkills?.split(",")?.length})`
                    : "-"}
                </div>
              </div>
              <div className="skillsNameChips">
                {data?.projectRelevantSkills?.length
                  ? data?.projectRelevantSkills
                      ?.split(",")
                      ?.map((item: string, index: any) => {
                        return (
                          <div key={index} className="skillsBullets">
                            <Bullets skillName={capitalizeFirstLetter(item)} />
                          </div>
                        );
                      })
                  : "-"}
              </div>
            </div>
          </div>
        </div>
        {/*---------------- Keywords */}
        <div className="cvExtractDetailRow">
          <div className="cvExtractDetailRow">
            <div className="titleWithValue">
              <div className="d-flex gap-1">
                <div className="title">{t("RESUME.SCANNING_KEYWORDS")}</div>
                <div className="percentage">
                  {data?.relevantKeywords
                    ? `(${data?.relevantKeywords?.split(",")?.length})`
                    : ""}
                </div>
              </div>
              <div className="skillsNameChips">
                {data?.relevantKeywords.length
                  ? data?.relevantKeywords
                      ?.split(",")
                      ?.map((item: string, index: any) => {
                        return (
                          <div key={index} className="skillsBullets">
                            <Bullets skillName={capitalizeFirstLetter(item)} />
                          </div>
                        );
                      })
                  : "-"}
              </div>
            </div>
          </div>
        </div>

        {/*---------------- Relevent projects */}
        <div className="cvExtractDetailRow">
          <div className="titleWithValue">
            <div className="title">
              {t("RESUME.SCANNING_RELEVANT_PROJECTS")}
            </div>
            <div className="percentage">
              {data?.relevantProjectsCount
                ? data?.relevantProjectsCount
                : "-"}{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="divider">
        <hr />
      </div>
      <div className="scoreCalculationSection">
        <div className="scoreCalcTitleSec">
          <span className="scoreCalcTitle">{t("GENERAL.AI_CV_SCORES")}</span>
          <div className="overAllScoreSec">
            <span className="overAllScore">{t("RESUME.SCANNING_OVERALL")}</span>
            <span className="overAllScoreValue">{data?.overAllRelevancy}%</span>
          </div>
        </div>
        <div className="pieChartSec">
          <PieChartComponent
            data={pieChartData}
            colors={colors}
            height={600}
            width={400}
          />
          <div className="colorWithLabel">
            {nameColorMap?.map((item: any, index: any) => {
              return (
                <div
                  key={index}
                  className="colorSquareValue"
                  onMouseEnter={() =>
                    item?.name !== "Unmatched" && setHoveredItem(item)
                  }
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <div
                    className="colorSquare"
                    style={{ backgroundColor: item?.color }}
                  />
                  <div className="colorValue">
                    {capitalizeFirstLetter(item?.name)}
                  </div>
                  <div className="lightBold">({item?.percentage}%)</div>
                  {/* Show details when hovered */}
                  {hoveredItem?.name === item?.name && (
                    <div className="pieChartToolTip">
                      <span style={{ color: item?.color }}>
                        {t("GENERAL.PARAMETER")} : {pieChartData[index]?.name}
                      </span>
                      <span>
                        {t("GENERAL.WEIGHTAGE")} :{" "}
                        {pieChartData[index]?.weightage} %
                      </span>
                      <span>
                        {t("GENERAL.MATCHED")} :{" "}
                        {pieChartData[index]?.matchedPercentage}%
                      </span>
                      <span>
                        {t("GENERAL.RESULT")}:{" "}
                        {pieChartData[index]?.value
                          ? pieChartData[index]?.value
                          : 0}
                        %
                      </span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="scoreCalcNote">
        <span className="note"> {t("GENERAL.NOTE")}</span> :{" "}
        {t("GENERAL.SCORE_CAL_INFO")}
      </div>
    </div>
  );
};

export default ScoreCalculationSidebar;
